import React from 'react';
import './NetworkErrorPopup.css';

const NetworkErrorPopup = ({ isVisible, onClose, message = "זוהה תקלה באפליקציה ויטופל בהקדם המכם הסליחה" }) => {
  if (!isVisible) return null;

  return (
    <div className="network-error-overlay">
      <div className="network-error-popup">
        <div className="network-error-header">
          <div className="network-error-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="10" stroke="#ef4444" strokeWidth="2" fill="none"/>
              <line x1="15" y1="9" x2="9" y2="15" stroke="#ef4444" strokeWidth="2"/>
              <line x1="9" y1="9" x2="15" y2="15" stroke="#ef4444" strokeWidth="2"/>
            </svg>
          </div>
          <h3>שגיאת חיבור</h3>
        </div>
        
        <div className="network-error-body">
          <p>{message}</p>
        </div>
        
        <div className="network-error-actions">
          <button 
            className="network-error-btn primary" 
            onClick={onClose}
          >
            הבנתי
          </button>
        </div>
      </div>
    </div>
  );
};

export default NetworkErrorPopup;